import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useIdentityPage } from '~/utils/identity/page';

const PrintButton = ({
  onClick,
}) => {
  const {
    isPrintingStaged,
  } = useIdentityPage();

  return !isPrintingStaged
    ? (
      <FontAwesomeIcon
        onClick={onClick}
        className="text-primary pl-3"
        icon="print"
      />
    ) : null;
};

PrintButton.propTypes = {
  onClick: PropTypes.func,
};

PrintButton.defaultProps = {
  onClick: undefined,
};

export default PrintButton;
